import { useSelector } from "react-redux";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import SidebarComponent from "./components/SidebarComponent";
import Topbar from "./components/Topbar";
import Company from "./pages/companies/company";
import CompanyList from "./pages/companies/companyList";
import Home from "./pages/reports/home";
import CompanyAcquisition from "./pages/reports/companyAcquisition.jsx";
import Login from "./pages/login/login";
import ChargebackList from "./pages/chargeback/chargebackList";
import Chargeback from "./pages/chargeback/chargeback.jsx";
import ImportColors from "./pages/colors/importColors.jsx";
import BotList from "./pages/bot/botList.jsx";
import ImportCustomer from "./pages/customer/importCustomer.jsx";
import Integration from "./pages/integration/integration.jsx";
import IntegrationError from "./pages/integration/integrationerrror.jsx";
import MireIntegration from "./pages/integration/mireIntegration.jsx";
import Monitoring from "./pages/monitoring/monitoring.jsx";
import MonitoringIntegration from "./pages/monitoring/monitoringIntegration.jsx";
const Layout = () => {
  const currentUser = useSelector((state) => state.user.currentUser);

  return (
    <div class="wrapper">
      {currentUser && Object.keys(currentUser).length > 0 ? (
        <header>
          <Topbar />
        </header>
      ) : (
        false
      )}
      <article>
        <Outlet />
      </article>
      {currentUser && Object.keys(currentUser).length > 0 ? (
        <aside>
          <SidebarComponent />
        </aside>
      ) : (
        false
      )}
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "company",
        element: <CompanyList />,
      },
      {
        path: "onboarding/:id",
        element: <Company />,
      },
      {
        path: "home",
        element: <Home />,
      },
      {
        path: "companyAcquisition",
        element: <CompanyAcquisition />,
      },
      {
        path: "chargebackList",
        element: <ChargebackList />,
      },
      {
        path: "chargeback",
        element: <Chargeback />,
      },
      {
        path: "importColors",
        element: <ImportColors />,
      },
      {
        path: "bot",
        element: <BotList />,
      },
      {
        path: "customers",
        element: <ImportCustomer />,
      },
      {
        path: "integration",
        element: <Integration />,
      },
      {
        path: "integrationError",
        element: <IntegrationError />,
      },
      {
        path: "mire",
        element: <MireIntegration />,
      },
      {
        path: "monitoring",
        element: <Monitoring />,
      },
      {
        path: "monitoringIntegration",
        element: <MonitoringIntegration />,
      },
    ],
  },
]);

function App() {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
